<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Tax id configuration</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content style="padding-top: 10px;">
    <form [formGroup]="taxTypeform">
        <div formArrayName="types">
           <div class="row" *ngFor="let item of types.controls; let i = index" [formGroupName]="i"> 
         <div class="col-sm-5 col-5" >
         <mat-form-field appearance="outline">
           <mat-label>Tax id name</mat-label>
           <input matInput #input formControlName="tax_type">
         </mat-form-field>
         </div>
         
         <div class="col-sm-6 col-5">
           <mat-form-field appearance="outline">
             <mat-label>Tax id number</mat-label>
             <input matInput #input formControlName="identification_no">   
           </mat-form-field>
        </div>
        <div class="col-sm-1 col-2">
           <span>
              <mat-icon style="    position: relative;
              top: 15px;
              color: #D70D0D; cursor: pointer;
          " (click)="removeFormFieldForTypes(i)">delete</mat-icon>
           </span>
         </div>
         
         </div>
         <div class="add_newrt">
           <button mat-flat-button color="primary" (click)="addTaxTypeField()" [disabled]="taxTypeform.invalid"> <mat-icon>add</mat-icon> Add tax</button>
         </div>

        </div>

      </form>
 
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button
      mat-button
      mat-dialog-close
  
    >
      Cancel
    </button>
    <button
    [disabled]="taxTypeform.invalid"
    (click)="onSaveInternationalTax()"
      mat-flat-button
      color="accent"
      
      
    >
    Confirm
    </button>

  </mat-dialog-actions>
  